import $ from 'jquery';
// import 'readmore-js/readmore';

import './readmore-fixed';

$(function () {
    if (window.innerWidth < 767) {
        $('.rw-search').readmore({
            embedCSS: true,
            moreLink: '<a href="#" class="font-proximanova-bold mt-3 text-uppercase"><small><i class="fas fa-chevron-right"></i></small> meer filters</a>',
            lessLink: '<a href="#" class="font-proximanova-bold mt-3 text-uppercase"><small><i class="fas fa-chevron-right"></i></small> Toon minder</a>',
            collapsedHeight: 160,
        });
    }

    $('.realworks__single__description__content').readmore({
        embedCSS: true,
        moreLink: '<a href="#" class="btn btn--primary mt-3">lees meer</a>',
        lessLink: '<a href="#" class="btn btn--primary mt-3" onclick="window.scrollTo(\'.realworks__single__description\')">lees minder</a>',
        collapsedHeight: 170,
    });
});

